module.exports = __webpack_public_path__ + "img/5_113.5c731ad0.png";